const { head, isSet } = require("lodash");

require("./bootstrap");

const imgElement = document.querySelector("img");
if (imgElement && imgElement.hasAttribute("data-fancybox")) {
    Fancybox.bind("[data-fancybox]", {
        // Your options go here
    });
}
let headerHeight = $("header").height();
let navHeight = $("nav").outerHeight();
let footerHeight = $("footer").outerHeight(true);

let sumHeight = headerHeight + navHeight + footerHeight;
let finalHeight = $(window).innerHeight() - sumHeight;

$(".main--page--content").css("min-height", `${finalHeight}px`);

if (typeof finalHeight !== "undefined") {
    setTimeout(function () {
        $("footer").addClass("isSet");
    }, 500);
}
